import { connect } from "react-redux";
import { MetrocorpExtracts } from "@ui-kit/components/index.es";
import { selectors as metrocorpSelectors } from "reducers/metrocorp";

const mapStateToProps = (state) => ({
    loading: metrocorpSelectors.getFetchingMonthlyReport(state),
    isVisible: metrocorpSelectors.isReportDrawerVisible(state),
    clients: metrocorpSelectors.getClients(state),
});

export default connect(mapStateToProps)(MetrocorpExtracts);
